import { create } from 'zustand';

interface LocationStore {
  directionResponse: google.maps.DirectionsResult | null;
  setDirectionResponse: (response: google.maps.DirectionsResult) => void;
}

export const useLocationStore = create<LocationStore>((set) => ({
  directionResponse: null,
  setDirectionResponse: (response) => set({ directionResponse: response }),
}));

interface RouteStore  {
  routePath: google.maps.LatLngLiteral[];
  setRoutePath: (path: google.maps.LatLngLiteral[]) => void;
}

export const useRouteStore = create<RouteStore>((set) => ({
  routePath: [],
  setRoutePath: (path) => set({ routePath: path }),
}));

interface MarkerStore  {
  markerPoints: google.maps.LatLngLiteral[];
  setMarkerPoints: (path: google.maps.LatLngLiteral[]) => void;
}

export const useMarkerStore = create<MarkerStore>((set) => ({
  markerPoints: [],
  setMarkerPoints: (points) => set({ markerPoints: points }),
}));